<template>
  <div class="caseList">
    <heads></heads>
    <div class="container">
      <div
        class="container-top"
        v-if="bannerArray"
        :style="{ '--background': 'url(' +'\''+ bannerArray.path +'\''+ ')' }"
      ></div>
      <div class="container-bottom">
        <!-- <div class="nav">
        <div v-for="(item, index) in navArray"
          :key="index" class="nav-item">
        <span
          :class="nav === index ? 'nac-active' : ''"
          @click="getNav(index)"
          >{{ item }}</span
        >
        <div class="underline" v-if="nav === index"></div>
        </div>
      </div> -->
        <div class="case-list" style="margin-top: 20px">
          <div
            class="case-item"
            @click="toDetail(item.id)"
            v-for="item in pageArray"
            :key="item.id"
          >
            <div class="case-item-pic">
              <img :src="item.image" alt />
            </div>
            <div class="case-item-text">
              <span class="title">
                {{ item.caseTypeName }}
              </span>
              <div class="tags">
                {{ item.title }}
              </div>
            </div>
            <div class="little-logo"><img :src="item.companyImage" alt /></div>
          </div>
          <div
            v-if="pageArray.length%3==2"
            class="case-item case-item-empty"
          >
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
   <homeBottomImage style="z-index:1000"></homeBottomImage>
   <quickContact :message="quickContactMessage"></quickContact>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre } from "@/util/util.js";
import axios from "axios";
import wxShare from "@/common/wx_share.js";
export default {
  name: "caseList",
  data() {
    return {
      pageNum: 1,
      pageSize: 12,
      total: 0,
      nav: 0,
      navArray: ["全部", "北京", "上海", "杭州"],
      id: 0,
      pageArray: [],
      bannerArray: [],
      loading: false,
      quickContactMessage:{
        type:1
      },
      companyId:null,
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact,
    homeBottomImage
  },
  computed: {
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
    // nav() {
    //   return this.$route.params.id;
    // }
  },
  methods: {
    handlePicPlusPre,
    // 获取广告
    getBanner() {
      const params = {
        positionId: 14,
        cityId:this.getLocationSiteCityId
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
           if(res.data &&res.data.code == 200){
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }else{
                this.bannerArray.path = "ak.jpg";
              }
              console.log(this.bannerArray)
            }
          }
        });
    },
    getNav(index) {
      this.nav = index;
    },
    toDetail(id) {
      window.open("/#/caseDetail?id="+id)
    },
    // -- 分页方法
    handleCurrentChange(val) {
      this.loading = true;
      this.dispatchQuery();
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    getCaseListByCompanyCityId() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        companyId: this.companyId
      };
      axios
        .get(`/api/case/listByCompany`, {
          params,
        })
        .then((res) => {
          console.log(res);
          if (res.data && res.data.code == 200) {
            this.total = res.data.total;
            this.pageArray = res.data.rows;
            if (this.pageArray) {
              this.pageArray.forEach((pageItem) => {
                if (pageItem.image) {
                  pageItem.image = handlePicPlusPre(pageItem.image);
                  pageItem.image = pageItem.image[0];
                }
                if (pageItem.companyImage) {
                  pageItem.companyImage = handlePicPlusPre(
                    pageItem.companyImage
                  );
                  pageItem.companyImage = pageItem.companyImage[0];
                }
              });
            }
          }
        });
    },
        // 查询调度方法
    async dispatchQuery(){
      if(this.companyId){
        await this.getCaseListByCompanyCityId();
      }else{
        await this.getCaseList();
      }
    },
    getCaseList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      axios
        .get(`/api/case/indexList`, {
          params,
        })
        .then((res) => {
          console.log(res);
          if (res.data && res.data.code == 200) {
            this.total = res.data.total;
            this.pageArray = res.data.rows;
            if (this.pageArray) {
              this.pageArray.forEach((pageItem) => {
                if (pageItem.image) {
                  pageItem.image = handlePicPlusPre(pageItem.image);
                  pageItem.image = pageItem.image[0];
                }
                if (pageItem.companyImage) {
                  pageItem.companyImage = handlePicPlusPre(
                    pageItem.companyImage
                  );
                  pageItem.companyImage = pageItem.companyImage[0];
                }
              });
            }
          }
        });
    },
  },
  mounted() {
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  created() {
    this.getBanner();
     if (this.$route.query) {
      console.log("this.$route.query");
      console.log(this.$route.query);
      if (this.$route.query.companyId) {
        this.companyId = this.$route.query.companyId;
        this.getCaseListByCompanyCityId();
      }else{
        this.getCaseList();
      }
     }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
.container-top {
  background: #f8f8f8;
  background-repeat: no-repeat;
  background-position-x: center;
  background-image: var(--background);
  background-size: 1920px 350px;
  height: 350px;
}
.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.container-bottom .nav {
  padding: 34px 0;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  text-align: center;
  width: 342px;
  margin: 0 auto;
}
.container-bottom .nac-active {
  font-weight: bold;
}
.nav span {
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  /* margin:0px 20px; */
}
.nav-item {
  padding: 0 20px;
}
.nav .underline {
  line-height: 10px;
  border-bottom: 2px solid #359ff8;
}
.case-list {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}
.case-list .case-item {
  width: 310px;
  height: 256px;
  background: #fff;
  margin-bottom: 20px;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.case-list .case-item:hover {
  cursor: pointer;
  box-shadow: 10px 10px 20px rgb(0 0 0 / 10%);
}
.case-list .case-item .case-item-pic {
  width: 100%;
  overflow: hidden;
  height: 180px;
}
.case-list .case-item .case-item-pic img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  transition: all 0.2s ease-in-out;
}
.case-list .case-item .case-item-text {
}
.case-item-text .title {
  font-size: 14px;
  color: #999;
  line-height: 40px;
  height: 40px;
  padding: 0 12px;
}
.case-item-text .tags {
  font-size: 15px;
  color: #222;
  padding: 0 12px;
  font-weight: 700;
}
.case-item .little-logo {
  position: relative;
}
.case-item .little-logo img {
  position: absolute;
  height: 40px;
  -o-object-fit: cover;
  object-fit: cover;
  right: 20px;
  bottom: 56px;
  border: 1px solid #f5f5f5;
}

.pagination {
  margin-bottom: 10px;
}
.case-item-empty{
  opacity: 0;
  cursor:auto!important;
}
</style>




// WEBPACK FOOTER //
// src/components/case/caseList.vue